import React, { useContext } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ContentFooter } from '../../../../../layout/Content'
import DailySalesFooterStyle from './css/DailySalesFooterStyle'
import ReportsController from '../../../../ReportsController'
import { appContext } from '../../../../../../App'
import { getMonthString, getMonthInteger } from '../../../../../utilities/utilities'
import { dailySalesControllerContext } from './DailySalesController'

function DailySalesFooter(props) {
  const app = useContext(appContext)
  const setContent = app.content[1]
  const dailySalesController = useContext(dailySalesControllerContext)
  const [month, setMonth] = dailySalesController.month
  const [year, setYear] = dailySalesController.year

  const onClickYearNextNav = (e) => {
    if (year === 9999) return
    if (year.toString().length === 4) setYear((prevYear) => prevYear + 1)
    else (setYear(1000))
  }
  const onClickYearPrevNav = (e) => {
    if (year === 1000) return
    if (year.toString().length === 4) setYear((prevYear) => prevYear - 1)
    else (setYear(9999))
  }

  const onChangeMonth = (e) => { setMonth(getMonthInteger(e.target.value)) }

  const onChangeYear = (e) => {
    if (e.target.value.length <= 4) {
      const year = e.target.value ? parseInt(e.target.value) : ''
      setYear(year)
    }
  }

  return (
    <ContentFooter>
      <div className='content-footer-container'>
        <div className='add-on-controls'>
          <div id='month-control-container' className='control-container'>
            <label htmlFor='month' style={{fontSize: '1rem', margin: 'auto', marginLeft: '0', marginRight: '0'}}>Month: </label>&nbsp;
            <select disabled={(year.toString().length !== 4)} onChange={onChangeMonth} value={getMonthString(month)}>
              <option>January</option>
              <option>February</option>
              <option>March</option>
              <option>April</option>
              <option>May</option>
              <option>June</option>
              <option>July</option>
              <option>August</option>
              <option>September</option>
              <option>October</option>
              <option>November</option>
              <option>December</option>
            </select>
          </div>
          <div id='year-control-container' className='control-container'>
            <label htmlFor='year' style={{fontSize: '1rem', margin: 'auto', marginLeft: '0', marginRight: '0'}}>Year: </label>&nbsp;
            <button
              onClick={onClickYearPrevNav}
              id='year-nav-left'
              className='nav-button'>
              <FontAwesomeIcon icon='caret-left'/>
            </button>
            <input
              id='year'
              value={year}
              onChange={onChangeYear}
              max='9999'
            />
            <button
              onClick={onClickYearNextNav}
              id='year-nav-right'
              className='nav-button'>
              <FontAwesomeIcon icon='caret-right'/>
            </button>
          </div>
        </div>

        <div className='action-btn-container'>
          <button
            onClick={() => { setContent(<ReportsController />) }}
            className='pospro-action-btn'>
            <FontAwesomeIcon icon='list-alt'/>&nbsp;Back to Reports
          </button>
        </div>
        <div className='action-btn-container'>
          <button
            onClick={ () => { window.print() } }
            className='pospro-action-btn'>
            <FontAwesomeIcon icon='print'/>&nbsp;Print
          </button>
        </div>
      </div>
      <DailySalesFooterStyle />
    </ContentFooter>
  )
}

export default React.memo(DailySalesFooter)
